import { useAddStation } from "../hooks/StationHooks";
import { StationDTO } from "../types/stationDTO";
import ValidationSummary from "../ValidationSummary";
import StationForm from "./StationForm";
import { toast } from 'react-toastify';
import { useState } from "react";
import { ClipLoader } from "react-spinners";
import { useTranslation } from 'react-i18next';
import { useParams } from "react-router-dom";

const StationAdd = () => {
  const { t } = useTranslation();
  const createValidToDate = () => {
    const date = new Date();
    date.setFullYear(2099);
    date.setSeconds(0, 0);
    return date;
  };
  const { organisationId } = useParams<{ organisationId: string }>();
  if (!organisationId) throw new Error("Missing organisationId from params");
  const [station, setStation] = useState<StationDTO>({
    id: "00000000-0000-0000-0000-000000000000",
    organisationId: organisationId,
    name: "",
    address: "",
    municipality: "",
    validFrom: new Date(new Date().setSeconds(0, 0)),
    validTo: createValidToDate(),
    lastModified: new Date(),
  });
  const addStationMutation = useAddStation(organisationId, setStation);

  return (
    <>
      {addStationMutation.isError && (
        <ValidationSummary error={addStationMutation.error} />
      )}
      {addStationMutation.isPending ? (
        <div className="spinner-container" style={{ textAlign: 'center', marginTop: '20px' }}>
          <ClipLoader size={50} color={"#123abc"} loading={true} />
          <p>{t('station.addWait')}</p>
        </div>
      ) : (
        <StationForm
          headerText={t('station.add')}
          station={station}
          submitted={(station) => {
            addStationMutation.mutate(station, {
              onSuccess: () => {
                toast.success(t('station.addSuccess'));
                history.back();
              },
              onError: () => {
                toast.error(t('station.addError'));
              }
            });
          }}
        />
      )}
    </>
  );
};

export default StationAdd;